import { render, staticRenderFns } from "./ContractDates.vue?vue&type=template&id=2442e825&"
import script from "./ContractDates.vue?vue&type=script&lang=js&"
export * from "./ContractDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VMenu,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686294843/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2442e825')) {
      api.createRecord('2442e825', component.options)
    } else {
      api.reload('2442e825', component.options)
    }
    module.hot.accept("./ContractDates.vue?vue&type=template&id=2442e825&", function () {
      api.rerender('2442e825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contracts/ContractDates.vue"
export default component.exports